import React, { createContext, useContext, useState } from 'react';
import { useAuth } from './AuthContext';
import AuthModal from '../components/AuthModal';
import ProfileModal from '../components/ProfileModal';
import PointsModal from '../components/PointsModal';

const ModalContext = createContext(null);

export const ModalProvider = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const [showAuth, setShowAuth] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [showPoints, setShowPoints] = useState(false);

  const openProfile = () => {
    if (isAuthenticated) setShowProfile(true);
    else setShowAuth(true);
  };

  const openPoints = () => {
    if (isAuthenticated) setShowPoints(true);
    else setShowAuth(true);
  };

  const openAuth = () => setShowAuth(true);

  return (
    <ModalContext.Provider value={{ openProfile, openPoints, openAuth }}>
      {children}
      <AuthModal isOpen={showAuth} onClose={() => setShowAuth(false)} />
      <ProfileModal
        isOpen={showProfile}
        onClose={() => setShowProfile(false)}
        onOpenPoints={() => setShowPoints(true)}
      />
      <PointsModal isOpen={showPoints} onClose={() => setShowPoints(false)} />
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);
